import Hero from "../components/home/Hero";
import Clients from "../components/home/Clients";
import ServicesPreview from "../components/home/ServicePreview";
import Testimonials from "../components/home/Testimonials";
import WhyUs from "../components/home/WhyUs";
import CTA from "../components/home/CTA";

const Home = () => {
  return (
    <>
      <Hero />
      <Clients />
      <ServicesPreview />
      <WhyUs />
      <Testimonials />
      <CTA />
    </>
  );
};

export default Home;
